/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createAction, props } from '@ngrx/store';
import { IAppLearningResp } from 'generated-types';

/**
 * Interface for app insights payload.
 */
interface IAppInsightsPayload {
    vsId: string;
    data: IAppLearningResp;
    lastUpdatedTimestamp: number;
}

const APP_INSIGHTS_SOURCE = '[App Insights]';

export const loadAppInsights = createAction(
    `${APP_INSIGHTS_SOURCE} Load Data`,
    props<{ vsId: string }>(),
);

export const loadAppInsightsSuccess = createAction(
    `${APP_INSIGHTS_SOURCE} Set App Insights Data`,
    props<IAppInsightsPayload>(),
);
